import { render, staticRenderFns } from "./RemessaInfo.vue?vue&type=template&id=06cc0b4a"
import script from "./RemessaInfo.vue?vue&type=script&lang=js"
export * from "./RemessaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports